<div class="map-popup" *ngIf="mapExpanded">
  <div class="hcf-popup-modal show-popup" (click)="closePopupMap()"></div>
  <div class="hcf-popup show-popup">
    <p class="mobile-bar">
      <a (click)="backTo()" class="back-link">{{ showSidebar ? 'Back to the map' : 'Back to results' }} </a>
    </p>
    <a (click)="closePopupMap()" aria-label="Close" title="Close" class="hcf-popup-close"></a>
    <div class="map-popup-legend">
      <div class="ap-popup-map-legend">Affiliated Provider</div>
      <div class="ec-popup-map-legend">Easy-Claim Partner</div>
      <div class="ap-ec-popup-map-legend">Affiliated Provider & Easy-Claim</div>
    </div>
    <sidebar
      *ngIf="showSidebar"
      [location]="selectedLocation"
      [locationType]="locationType"
      (closeMapEventEmitter)="closePopupMap($event)">
    </sidebar>
    <hcf-map class="hcf-map" [places]="placesForMap" [latitude]="latitude" [longitude]="longitude" [isPopup]="true">
    </hcf-map>
  </div>
</div>
